import { TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY } from "./transitPath.configuration";

/**
 * Whether a remaining realtime stop is the trip terminus (distinct from the next stop).
 *
 * @param stopIndex Index within the remaining segment.
 * @param stopCount Number of stops in the remaining segment.
 * @returns True when this is the last remaining stop and not the only one left.
 */
export function isRealtimeRemainingTerminusStop( stopIndex: number, stopCount: number ): boolean {
    return stopCount > 1 && stopIndex === stopCount - 1;
}

/**
 * Resolves collision priority for a realtime transit path stop label.
 *
 * @param stopIndex Index within the past or remaining segment.
 * @param stopCount Number of stops in that segment.
 * @param isPast Whether the stop is on the traversed segment.
 * @returns Priority value for transit-path stop label collision sorting.
 */
export function resolveRealtimeTransitPathStopLabelPriority(
    stopIndex: number,
    stopCount: number,
    isPast: boolean,
): number {
    if ( isPast ) {
        return TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY.realtimePast;
    }

    if ( stopIndex === 0 ) {
        return TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY.realtimeNextStop;
    }

    if ( isRealtimeRemainingTerminusStop( stopIndex, stopCount ) ) {
        return TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY.realtimeTerminus;
    }

    return TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY.intermediate;
}
